
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2014","transform":"translate(-142 -431)"}},[_c('rect',{attrs:{"data-name":"Rectangle 3608","width":"250","height":"625","rx":"80","transform":"translate(142 806)","fill":"#218665"}}),_c('rect',{attrs:{"data-name":"Rectangle 3609","width":"250","height":"1000","rx":"80","transform":"translate(517 431)","fill":"#0fa"}}),_c('rect',{attrs:{"data-name":"Rectangle 3610","width":"250","height":"800","rx":"80","transform":"translate(892 631)","fill":"#999"}})])])
          )
        }
      }
    